export const regEmailOrPhoneNumberWithPlusSign = /\S+@\S+\.\S+|^\+\d+$/
